/* eslint-disable quotes */
import axios from 'axios'
import { Toast } from "vant";



axios.defaults.baseURL = process.env.VUE_APP_PATH
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.transformRequest = [data => {
  let ret = ''
  for (const it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret
}]


//freshTimeStamp()
axios.interceptors.request.use(function (config) {
  
  return config
})

axios.interceptors.response.use(function (response) {
  
  return response
})




export { axios }
